import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import topic from 'dojo/topic';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MessageAck.html?raw';
//import GenericDialog = require("../../UI/GenericDialog/GenericDialog");
//import "../../UI/GenericDialog/GenericDialog";
//import DataItems = require("DataItems");

import { MessageAck_ConfirmationType } from "./enum";

interface MessageAck_ConfirmationData {
    identifierKey: string;
    confirmationType: MessageAck_ConfirmationType;
}
class MessageAck extends compose(_WidgetBaseSP) {
    templateString: any = template;

    confirmationData: MessageAck_ConfirmationData;

    protected _callback: Function = null;

    // diverse Nodes:
    
    sendRequest(messageData?: MessageAck_ConfirmationData, type?: MessageAck_ConfirmationType) {

        console.debug("MessageAck sendRequest", messageData);

        if (messageData != null && typeof (messageData) != "undefined") {
            this.confirmationData = messageData;

            if (typeof (type) != "undefined") {
                this.confirmationData.confirmationType = type;
            } else {
                this.confirmationData.confirmationType = MessageAck_ConfirmationType.markAsRead;
            }
        }
        //this.confirmationData = {
        //    identifierKey: this.getUrlParameterValue("guid"),
        //};

        //console.log("MessageAck SendRequest confirmationdata", this.confirmationData);


        this.RequestManager.post(window.appRoot + "Operation_MessageAck/ConfirmMessage",
            {
                "jsonData": JSON.stringify(this.confirmationData)
            },
            lang.hitch(this, this._onSendRequestResponse),
            lang.hitch(this, this._onSendRequestError),
            false            
        );
    }

    protected _onSendRequestResponse(response: object): void {
        console.log("_onSendRequestResponse", response);

        topic.publish("Messages/Confirmed", response);

        this.showErrorMessage("");
    }

    protected _onSendRequestError(error: more.requestErrorMessage): void {
        this.showErrorMessage(error.Message);
        console.error("_onSendRequestError", error.url, error.Message);
    }

    showErrorMessage(message?: string) {
        if (message == null || typeof (message) == "undefined" || message == "") {
            
        } else {
            alert("Message confirmation failed: " + message);
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        
    }

    setCallback(callbackFct: Function) {
        this._callback = callbackFct;
    }

    startup(identifierKey?: string, type?: keyof typeof MessageAck_ConfirmationType, args?: any): void {
        super.startup.apply(this, arguments as any);

        if (typeof (type) == "undefined") {
            type = MessageAck_ConfirmationType.markAsRead;
        }

        let messageData: MessageAck_ConfirmationData = { identifierKey: identifierKey, confirmationType: MessageAck_ConfirmationType[type] };

        //console.debug("MessageAck startup", identifierKey, type, messageData);

        this.sendRequest(messageData, MessageAck_ConfirmationType[type]);
    }

}

export default mdsWidget(MessageAck);
